import axios from 'axios'
import {config} from '@/assets/js/config/base'
import {storageLocal} from '@/assets/js/libs/localstorage'
export const setBearer = () => {
  return new Promise(resolve => {
    storageLocal.get([config.local.jwtName])
      .then(
        response => {
          resolve('Bearer ' + response[0])
        }
      )
      .catch(
        () => {
          resolve(null)
        }
      )
  })
}
export const http = () => {
  return new Promise(resolve => {
    setBearer()
      .then(
        bearer => {
          let http = axios.create({
            baseURL: config.api.url,
            headers: {
              'Authorization': bearer,
              'Content-Type': 'application/json',
              'Accept': 'application/json'
            }
          })
          resolve(http)
        }
      )
  })
}



// WEBPACK FOOTER //
// ./src/api/headers.js